import { Area } from './area.model'
import { updateEventStructure } from './updateEventStructure.model'
import { CLIENT_ID, CreateShiftAndBillingInput, ShiftAndBillingType } from './client.model'
import { ENTRANCE_ID } from './entrance.model'
import { EVENT_ID, EventBase, AreasStatistics, EventStatistics } from './event.model'
import { Station } from './station.model'
import { Location } from './location.model'
import { StationType, PassSecurityLevel, AreaType } from '../../app/shared/app.enums'

export type BranchStatus = 'running' | 'upcoming' | 'incomplete' | 'finished' | 'inactive'

export type NursingType = 'private' | 'institutional'

export class Branch extends EventBase {
  club_ids: string = ''
  entrances: BranchEntrances[]
  event_statistics: BranchStatistics
  areas: Array<Area> = []
  areas_statistics: AreasStatistics
  predefined_location_id?: number = NaN
  entrancesAmount?: number
}

export class BranchStatistics extends EventStatistics {
  /*   kpis: BranchKpis; */
  totalToday: number = NaN
  totalInside: number = NaN
  totalOvertime: number = NaN
}

/* export class BranchKpis extends EventKpis {
  totalToday: number = NaN;
  totalInside: number = NaN;
  totalOvertime: number = NaN;
} */

export class BranchWithStatus extends Branch {
  status: BranchStatus = 'upcoming'
  selected_area: number | null = null
  pass_status: string | null = null
  pass_category: number[] | null = null
  /**
   * The KIND of area that was clicked on the dashboard, when it matters (YB-2066).
   *
   * Only ever `AreaType.BOOKABLE`: the pass-backed types are already distinguishable by the
   * `pass_category` they set, and a room sets none because there is no pass table to filter — it
   * routes to the bookings calendar instead. Client-side view state, like the three above.
   */
  selected_area_type: AreaType | null = null
}

export class CreateBranchInput {
  name: string = ''
  client_id: CLIENT_ID = NaN
  max_enforce: boolean = false
  allow_transfer: boolean = false
  max_participants: number = NaN
  password: string = ''
  station_type? = StationType.front_camera
  address: string = ''
  lat: number = NaN
  lon: number = NaN
  description: string = ''
  external_code: string = ''
  category: Array<string> = []
  keep_open?: boolean = false
  time_limitations?: string = ''
  contact_name?: string = ''
  contact_email?: string = ''
  contact_country_code?: string = ''
  contact_mobile?: string = ''
  contact_fax?: string = ''
  create_time?: string = ''
  nursing_type?: NursingType = 'private'
  id_number?: string = ''
  shifts_billing?: CreateShiftAndBillingInput | null = null
  related_id?: Array<number> = []
  anonymous_related?: boolean = false
  post_scan_transfer?: boolean = false
  report_location?: boolean = false
  secured?: PassSecurityLevel
}

export class UpdateBranchInput extends CreateBranchInput {
  id: EVENT_ID = NaN
  update_event_structure?: updateEventStructure[] = []
  update_location: Location = {} as Location
}

export class BranchResponse {
  id: EVENT_ID = NaN
  client_id: CLIENT_ID = NaN
  name?: string = ''
  external_code?: string = ''
  password?: string = ''
  max_participants?: number = NaN
  max_enforce?: boolean = false
  restrictions?: string = ''
  allow_transfer?: boolean = false
  station_type? = StationType.front_camera
  location: Location
  image?: string = ''
  keep_open?: boolean = false
}

export class BranchEntrances {
  id: ENTRANCE_ID
  name: string = ''
  icon: string = ''
  stations?: Station[]
  areas?: Area[]
  parentEntrances?: BranchEntrances[] = []
  subEntrances?: BranchEntrances[] = []
  parent_id?: number = NaN
  type?: string = ''
}

export class ShiftsAndBilling {
  name: string = ''
  type: ShiftAndBillingType = 'regular'
  days_start: number = NaN
  days_end: number = NaN
  hours_start: string = ''
  hours_end: string = ''
  fee: number = NaN
}
